import React from 'react'

const RouteVersion = () => (
  <div>
    <div>commit: {process.env.REACT_APP_GIT_REVISION || 'development'}</div>
    <div>branch: {process.env.REACT_APP_GIT_BRANCH || 'development'}</div>
    <div>built: {process.env.REACT_APP_DATE_BUILT}</div>
  </div>
)

export default RouteVersion



// WEBPACK FOOTER //
// ./src/routes/version.js